import React, { useEffect, useState } from "react";
import Layout from "../../../../Components/Layout";
import detailsClass from "./details.module.css";
import { FaUser } from "react-icons/fa";
import { AiFillThunderbolt } from "react-icons/ai";
import { MdOutlineEmail } from "react-icons/md";
import Profile from "./Profile/profile";
import { Helmet } from "react-helmet";
import ActivityData from "./Activity";
import Communications from "./Communications";
import { useNavigate } from "react-router-dom";
import { AccessControl } from "Util/AccessControl";
import { AccessKeys } from "../../../../Routes/config";
import { Services } from "Services";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { use } from "react";

function Details() {
    const Navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isActive, setIsActive] = useState("Profile");
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState("1");
    const [data, setData] = useState([]);
    const [isOnLeave, setIsOnLeave] = useState(data?.on_leave == 1 ? true : false);

    const tabHandler = (e) => {
        const btnType = e.currentTarget.getAttribute("btn-type");
        setIsActive(btnType);
        setLoading(true);
    };
    const backButton = () => {
        Navigate(-1);
    };
    const backgroundColor = (status) => {
        return status == 2 ? "red" : "green";
    };
    const changeHandler = (e) => {
        let value = e.target.value;
        const token = {
            Authorization: `token ${localStorage.getItem("token")}`,
        };
        Services.changeAdminStatus(
            "PUT",
            JSON.stringify({ Status: e.target.value }),
            token,
            searchParams.get("ID")
        )
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    console.log(value);
                    setStatus(value);
                    toast.success(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (response.Status === 0) {
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const onLeaveHandler = (e) => {
        const newValue = !isOnLeave ? 1 : 0;
        const token = {
            Authorization: `token ${localStorage.getItem("token")}`,
        };
        Services.UpdateAdmin(
            "PUT",
            JSON.stringify({ on_leave: newValue }),
            token,
            searchParams.get("ID")
        )
            .then((response) => {
                if (response.Status === 1) {
                    setIsOnLeave(!isOnLeave);
                    toast.success(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (response.Status === 0) {
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        setStatus(data.Status);
        setIsOnLeave(data.on_leave == 1);
    }, [data]);

    return (
        <Layout Active={"Administrators"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Administrator</title>
            </Helmet>
            <div className={detailsClass["Container"]}>
                <button onClick={backButton} className={detailsClass["back"]}>
                    Back
                </button>
                <div className={detailsClass["wrapper"]}>
                    <h3
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                        }}>
                        Administrator:
                        {data.FirstName} {data.LastName}
                        <div
                            className={detailsClass["status-buttons"]}
                            style={{ marginLeft: "0.5rem" }}>
                            {AccessControl(AccessKeys.Administrators)?.edit ===
                                1 && (
                                    <>
                                        <select
                                            onChange={changeHandler}
                                            value={status}
                                            style={{
                                                color: "white",
                                                backgroundColor:
                                                    backgroundColor(status),
                                            }}>
                                            <option value="1">Active</option>

                                            <option value="2">Dormant</option>
                                        </select>
                                        <label
                                            className={detailsClass["toggle"]}
                                            style={{ marginLeft: "1rem",display:'flex',gap:'0.5rem' } }>
                                                 <p
                                                className={
                                                    detailsClass["toggle-label"]
                                                }>
                                                On Leave
                                            </p>
                                            <input
                                                className={
                                                    detailsClass[
                                                    "toggle-checkbox"
                                                    ]
                                                }
                                                type="checkbox"
                                                checked={isOnLeave}
                                                onChange={onLeaveHandler}
                                            />
                                            <div
                                                className={
                                                    detailsClass[
                                                    "toggle-switch"
                                                    ]
                                                }
                                            />
                                           
                                        </label>
                                    </>
                                )}
                        </div>
                    </h3>
                    <div className={detailsClass["control-btns"]}>
                        <button
                            className={`${detailsClass["button"]} ${isActive == "Profile"
                                ? detailsClass["btn-active"]
                                : ""
                                }`}
                            btn-type="Profile"
                            onClick={tabHandler}>
                            <FaUser /> Profile
                        </button>

                        <button
                            className={`${detailsClass["button"]} ${isActive == "Activity"
                                ? detailsClass["btn-active"]
                                : ""
                                }`}
                            btn-type="Activity"
                            onClick={tabHandler}>
                            <AiFillThunderbolt />
                            Activity
                        </button>
                        <button
                            className={`${detailsClass["button"]} ${isActive == "Email"
                                ? detailsClass["btn-active"]
                                : ""
                                }`}
                            btn-type="Email"
                            onClick={tabHandler}>
                            <MdOutlineEmail />
                            Email
                        </button>
                    </div>
                    {isActive === "Profile" && (
                        <Profile
                            loading={loading}
                            setLoading={setLoading}
                            data={data}
                            setData={setData}
                        />
                    )}
                    {isActive === "Activity" && <ActivityData data={data} />}
                    {isActive === "Email" && <Communications />}
                </div>
            </div>
        </Layout>
    );
}

export default Details;
